var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import keyby from 'lodash.keyby';
import cx from 'classnames';
import Menu from '../menu';
import { MenuItem } from '../menu/menu';
import { borderRadius } from '../theme/border-radius';
import { Tooltip } from '../tooltip/tooltip';
import { ChevronRight } from 'styled-cssgg';
import { DropdownContext, defaultValue, useDropdown, } from './dropdown-context';
import useOnClickOutside from '../hooks/use-click-outside';
import { useMenu } from '../menu/menu-context';
import { TooltipContext, defaultValue as tooltipDefaultValue, } from '../tooltip/tooltip-context';
const StyledDropdownMenuItemInner = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const StyledDropdownRightMenu = styled(Tooltip) `
  width: 100%;
`;
const DropdownRightMenu = (props) => {
    return (React.createElement(StyledDropdownRightMenu, { debugKey: "drop", trigger: "hover", visible: props.visible, content: props.content, placement: "rightStart", offset: 0, "data-role": "dropdown-right-menu" },
        React.createElement(StyledDropdownMenuItemInner, null,
            props.children,
            React.createElement(ChevronRight, null))));
};
const StyledDropdownMenuItem = styled(MenuItem) `
  div[data-role='tooltip'] {
    width: 100%;
  }
`;
export const DropdownMenuItem = (_a) => {
    var { collapsedMenu, onClick } = _a, props = __rest(_a, ["collapsedMenu", "onClick"]);
    const [selected, setSelected] = useState(false);
    const { onChangeVisible, rightVisible, onChangeRightVisible, mode } = useDropdown();
    const { subMenuPopupVisible, handleSubMenuPopupVisible } = useMenu();
    const handleRightClick = ({ itemKey }) => {
        onClick === null || onClick === void 0 ? void 0 : onClick({ itemKey });
    };
    const itemRef = useRef(null);
    const controlledSelected = props.selected || selected;
    useOnClickOutside(itemRef, () => {
        handleSubMenuPopupVisible === null || handleSubMenuPopupVisible === void 0 ? void 0 : handleSubMenuPopupVisible(false);
    }, { disable: false, includes: [] });
    const handleClickItem = () => {
        handleRightClick({ itemKey: props.itemKey });
        if (mode === 'switch') {
            return;
        }
        if (rightVisible && !collapsedMenu) {
            onChangeRightVisible(false);
        }
        if (!rightVisible && collapsedMenu) {
            onChangeRightVisible(true);
        }
        if (!collapsedMenu) {
            onChangeVisible(false);
        }
    };
    const handleOverItem = () => {
        setSelected(true);
        if (collapsedMenu) {
            handleSubMenuPopupVisible === null || handleSubMenuPopupVisible === void 0 ? void 0 : handleSubMenuPopupVisible(true);
        }
    };
    const handleLeaveItem = () => {
        setSelected(false);
        handleSubMenuPopupVisible === null || handleSubMenuPopupVisible === void 0 ? void 0 : handleSubMenuPopupVisible(false);
    };
    return (React.createElement(StyledDropdownMenuItem, Object.assign({ ref: itemRef, selected: controlledSelected }, props, { onClick: handleClickItem, onMouseEnter: handleOverItem, onMouseLeave: handleLeaveItem, "data-role": "dropdown-menu-item", className: props.className }), collapsedMenu ? (React.createElement(DropdownRightMenu, { key: "drop", visible: rightVisible === false ? false : subMenuPopupVisible, content: collapsedMenu }, props.children)) : (props.children)));
};
const StyledDropdownMenu = styled(Menu) `
  overflow: hidden;
  padding: 4px;
  line-height: 24px;
  --ggs: 0.75;
  border-radius: ${borderRadius.sm};
`;
export const DropdownMenu = (props) => {
    const { mode, switchKey } = useDropdown();
    const groups = useMemo(() => {
        return mode === 'switch' ? keyby(React.Children.toArray(props.children), 'props.itemKey') : {};
    }, [mode, props.children]);
    if (mode === 'switch') {
        return (React.createElement(StyledDropdownMenu, { className: props.className, size: "sm", "data-role": "dropdown-menu" }, groups[switchKey]));
    }
    return (React.createElement(StyledDropdownMenu, { className: props.className, "data-role": "dropdown-menu" }, props.children));
};
export const Dropdown = (props) => {
    const child = useRef(null);
    const mode = 'switchKey' in props ? 'switch' : 'nest';
    const [visible, setVisible] = useState(props.visible || defaultValue.visible);
    const [rightVisible, setRightVisible] = useState();
    const controlledVisible = 'visible' in props ? props.visible : visible;
    const handleVisible = useCallback((value) => {
        setVisible(value);
    }, []);
    const handleRightVisible = useCallback((value) => {
        setRightVisible(value);
    }, []);
    const handleMouseEnter = () => {
        setVisible(true);
    };
    const handleClick = () => {
        setVisible(true);
    };
    useOnClickOutside(child, () => {
        setVisible(false);
    }, { disable: false, includes: [] });
    return (React.createElement(DropdownContext.Provider, { value: Object.assign(Object.assign({}, defaultValue), { switchKey: props.switchKey, mode, visible: controlledVisible, isDropdown: true, onChangeVisible: handleVisible, rightVisible, onChangeRightVisible: handleRightVisible }) },
        React.createElement(TooltipContext.Provider, { value: Object.assign(Object.assign({}, tooltipDefaultValue), { showArrow: false, animation: 'opacity', outsideCloseable: false }) },
            React.createElement(Tooltip, { content: React.createElement("div", { ref: child }, props.content), visible: controlledVisible, placement: props.placement, "data-role": "dropdown", id: props.id, onMouseEnter: handleMouseEnter, onClick: handleClick, getPopupContainer: props.getPopupContainer, trigger: props.trigger, className: cx('dropdown', props.className) }, props.children))));
};
